<div class="alert alert-success" role="alert" *ngIf="alertOk">
  {{ alertOk | translate }}
</div>

<div class="alert alert-success" role="alert" *ngIf="alertError">
  {{ alertError }}
</div>

<div *ngIf="!_userService.user">
  <h1 class="main-color">{{'ASK_FOR_A_SECOND_OPINION' | translate }}</h1>
  <p [innerHtml]="'SECOND_OPINION_TEXT_NO_LOGIN' | translate"></p>
</div>

<div *ngIf="_userService.user">
  <h1 class="main-color">{{'CREATE_NEW_MEDICAL_CONSULTATION' | translate }}</h1>
  <p>{{'SECOND_OPINION_TEXT_LOGIN' | translate }}</p>

  <form [formGroup]="secondOpinionForm" (ngSubmit)="validateForm()">

    <loading-component *ngIf="_resourceService.loading"></loading-component>

    <div class="row">

      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'DEPARTMENT' | translate }}</label>
          <div class="input-group mb-3">
            <select class="form-control" [(ngModel)]="secondOpinionData.departmentId"
              name="department" placeholder="Select department" formControlName="department"
              (ngModelChange)="getSpecialities($event)">
              <option *ngFor="let department of _resourceService.departments"
                [value]="department.id">
                {{ department.name }}</option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary"
                (click)="secondOpinionData.departmentId = null"
                [disabled]="!secondOpinionData.departmentId">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'ORGANIZATIONAL_UNIT' | translate }}</label>
          <div class="input-group mb-3">
            <select class="form-control" [(ngModel)]="secondOpinionData.specialityId"
              name="speciality" placeholder="Select speciality" formControlName="speciality">
              <option *ngFor="let speciality of specialities" [value]="speciality.id">
                {{ speciality.name }}</option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary"
                (click)="secondOpinionData.specialityId = null"
                [disabled]="!secondOpinionData.specialityId">
                <i class="fas fa-trash-alt icon-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="subject">{{ 'SUBJECT' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.subject" name="subject"
            [placeholder]="'HELP_SUBJECT' | translate" formControlName="subject"
            rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="whatWrong">{{ 'WHAT_WRONG' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.whatWrong" name="whatWrong"
            formControlName="whatWrong" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="sinceWhen">{{ 'SINCE_WHEN_HAPPEN' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.sinceWhen" name="sinceWhen"
            formControlName="sinceWhen" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="whatAttribute">{{ 'WHAT_DO_YOU_ATTRIBUTE_IT' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.whatAttribute"
            name="whatAttribute" formControlName="whatAttribute" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="howBegan">{{ 'HOW_IT_BEGAN' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.howBegan" name="howBegan"
            formControlName="howBegan" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="symptoms">{{ 'WHAT_SYMPTOMS_DO_YOU_HAVE' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.symptoms" name="symptoms"
            formControlName="symptoms" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="intensity">{{ 'HOW_INTENSE_ARE_THESE_SYMPTOMS' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.intensity" name="intensity"
            formControlName="intensity" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label
            for="whatChange">{{ 'IN_WHAT_CIRCUMSTANCES_ARE_THE_SYMPTOMS_AGGRAVATED_OR_REDUCED' | translate }}</label>
          <textarea class="form-control" [(ngModel)]="secondOpinionData.whatChange"
            name="whatChange" formControlName="whatChange" rows="3"></textarea>
        </div>
      </div>
    </div>








    <div class="form-group row margin-top">
      <div class="form-group col-md-6">
        <button type="submit" class="btn btn-main-color btn-block">
          {{ 'SEND' | translate}}
        </button>
      </div>
      <div class="col-md-6">
        <div class="btn btn-secondary-color btn-block" (click)="resetForm()">
          {{ 'RESET' | translate}}
        </div>
      </div>
    </div>

  </form>
</div>